import { render, staticRenderFns } from "./StudioAdminSubPage.vue?vue&type=template&id=69dc5e00"
import script from "./StudioAdminSubPage.vue?vue&type=script&lang=js"
export * from "./StudioAdminSubPage.vue?vue&type=script&lang=js"
import style0 from "./StudioAdminSubPage.vue?vue&type=style&index=0&id=69dc5e00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports